module.exports = __webpack_public_path__ + "static/logo-80153ca3d1b799b0c1cea5fe2495e71d.png";